// iOS blockiert autoplay im Stromsparmodus und zeigt dann den nativen
// Play-Button. Schmuckvideos werden in dem Fall durch ihr Poster ersetzt.
function replaceWithPoster(video) {
    const poster = video.getAttribute('poster');
    if (!poster) return false;

    const img = document.createElement('img');
    img.src = poster;
    img.alt = '';
    if (video.id) img.id = video.id;
    img.className = video.className;
    const inlineStyle = video.getAttribute('style');
    if (inlineStyle) img.setAttribute('style', inlineStyle);

    video.replaceWith(img);
    return true;
}

export function initLazyVideos(scope = document) {
    const videos = Array.from(scope.querySelectorAll('video[data-lazy]'));
    if (!videos.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const video = entry.target;
            video.querySelectorAll('source[data-src]').forEach(source => {
                source.src = source.getAttribute('data-src');
                source.removeAttribute('data-src');
            });
            video.load();
            if (video.hasAttribute('autoplay')) {
                video.muted = true;
                video.play().catch(() => {
                    if (!replaceWithPoster(video)) {
                        // Ohne Poster: beim ersten Touch erneut versuchen –
                        // im User-Gesture erlaubt Safari play() auch im Stromsparmodus
                        document.addEventListener('touchstart', () => {
                            video.play().catch(() => {});
                        }, { once: true });
                    }
                });
            }
            observer.unobserve(video);
        });
    }, { rootMargin: '200px' });

    videos.forEach(video => observer.observe(video));
}